import { Button } from "@mui/material";
import { ErrorIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const Error400SignInPage: React.FunctionComponent = (_) => {
  const { t } = useResource();

  const signOut = useSignOut();

  return (
    <UnauthenticatedLayout title={"Error"}>
      <EmptyPage
        icon={<ErrorIcon />}
        title={t(Resources.Errors.Error400SignIn.Title)}
        subtitle={t(Resources.Errors.Error400SignIn.Subtitle, { email: ANALYZER_EMAIL })}
        actions={
          <Button variant="contained" onClick={() => signOut()}>
            {t(Resources.Errors.Error400SignIn.Button)}
          </Button>
        }
      />
    </UnauthenticatedLayout>
  );
};
